var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('selectComponent',{attrs:{"justSelect":true},on:{"selectedComponentFunc":_vm.selectedComponentFunc}}),(_vm.filteredComponents.length > 0)?_c('div',[_c('allMyComponentsTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"components":_vm.filteredComponents}})],1):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("All Components")])])
}]

export { render, staticRenderFns }